var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#212529",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4248 12L15.9121 8.51262C15.9684 8.45626 16 8.37985 16 8.30019C16 8.22053 15.9683 8.14415 15.9119 8.08786C15.8556 8.03156 15.7791 7.99996 15.6995 8C15.6198 8.00004 15.5434 8.03173 15.4871 8.08809L11.9998 11.575L8.51285 8.08809C8.48498 8.06018 8.45188 8.03804 8.41545 8.02293C8.37901 8.00781 8.33996 8.00002 8.30052 8C8.26108 7.99998 8.22201 8.00773 8.18556 8.0228C8.14912 8.03787 8.11599 8.05998 8.08809 8.08786C8.03173 8.14415 8.00004 8.22053 8 8.30019C7.99998 8.33963 8.00773 8.3787 8.0228 8.41514C8.03788 8.45159 8.05998 8.48472 8.08786 8.51262L11.5748 12L8.08786 15.4874C8.05998 15.5153 8.03787 15.5484 8.0228 15.5849C8.00773 15.6213 7.99998 15.6604 8 15.6998C8.00002 15.7393 8.00781 15.7783 8.02293 15.8147C8.03804 15.8512 8.06018 15.8843 8.08809 15.9121C8.11599 15.94 8.14912 15.9621 8.18556 15.9772C8.22201 15.9923 8.26108 16 8.30052 16C8.33996 16 8.37901 15.9922 8.41545 15.9771C8.45188 15.962 8.48498 15.9398 8.51285 15.9119L11.9998 12.425L15.4871 15.9119C15.515 15.9398 15.5481 15.962 15.5846 15.9771C15.621 15.9922 15.66 16 15.6995 16C15.7389 16 15.778 15.9923 15.8144 15.9772C15.8509 15.9621 15.884 15.94 15.9119 15.9121C15.9398 15.8843 15.962 15.8512 15.9771 15.8147C15.9922 15.7783 16 15.7393 16 15.6998C16 15.6604 15.9923 15.6213 15.9772 15.5849C15.9621 15.5484 15.94 15.5153 15.9121 15.4874L12.4248 12Z",
    fill: "#F1F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/close_gray.4367bf8faf935f050cd35f68c91d237f.svg";
export { ForwardRef as ReactComponent };